import { Text } from "components/commons";
import { dateFormat, formatAmount, formatVolume, timeFormat } from "utils";

export const mapDataToList = ({ transactions }) => {
  const {
    name,
    transactionNumber,
    processedAt,
    receiptNumber,
    cashier,
    approvedBy,
    sku,
    type,
    quantity,
    discount,
    originalPricePerItem,
    amount,
  } = transactions;

  return {
    date: (
      <>
        <Text>{dateFormat(processedAt ?? "")}</Text>
        <Text>{timeFormat(processedAt ?? "", true)}</Text>
      </>
    ),
    salesInvoiceNo: <Text>{receiptNumber ?? "--"}</Text>,
    transactionNo: <Text>{transactionNumber || "--"}</Text>,
    cashier: <Text>{cashier || "--"}</Text>,
    approvedBy: <Text>{approvedBy || "--"}</Text>,
    description: <Text>{name || "--"}</Text>,
    sku: <Text>{sku || "--"}</Text>,
    qty: <Text>{type === "fuel" ? formatVolume(quantity ?? 0) : quantity || "--"}</Text>,
    unitPrice: <Text>{formatAmount(originalPricePerItem || 0)}</Text>,
    discount: <Text>{formatAmount(discount ?? 0)}</Text>,
    refund: <Text>{formatAmount(amount)}</Text>,
  };
};

export const mapFilterToRequest = (filterState) => {
  const { ...fs } = filterState;

  return {
    ...fs,
  };
};
